import type { DataContainer } from "@otto-ec/tracking-bct";
import { moduleLogger } from "../util";

const log = moduleLogger.scope("detailview.model");

export type Detailview = {
	benefitId: string;
	frameId?: string;
	activeUntil: string;
	variationId: string;
	activationStatus: ActivationStatus;
	tracking: Tracking;
	isAppOnly: boolean;
	isEarlyAccess?: boolean;
};

export class Tracking {
	constructor(
		readonly id: string,
		readonly name: string,
		readonly labels: DataContainer,
	) {}
}

export enum ActivationStatus {
	DEACTIVATED = "DEACTIVATED",
	ACTIVATED = "ACTIVATED",
}

export function buildDetailview(detailviewBenefitElement: HTMLElement, sublineElement: HTMLElement, variationId: string): Detailview | null {
	const isAppOnly = sublineElement.dataset.isAppOnly === "true";
	const activationStatus = sublineElement.dataset.activationStatus as ActivationStatus;
	const isEarlyAccess = sublineElement.dataset.isEarlyAccess === "true";

	const benefitId = sublineElement.dataset.benefitId;
	if (!benefitId) {
		log.error("Missing benefitId");
		return null;
	}
	const frameId = sublineElement.dataset.frameId;
	const activeUntil = sublineElement.dataset.activeUntil;
	if (!activeUntil) {
		log.error("Missing activeUntil");
		return null;
	}

	const tracking = detailviewBenefitElement.dataset.tracking;

	if (!tracking) {
		log.error("Missing tracking");
		return null;
	}

	return {
		benefitId,
		frameId,
		activeUntil,
		activationStatus,
		tracking: JSON.parse(tracking) as Tracking,
		variationId,
		isAppOnly,
		isEarlyAccess,
	};
}
